import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import swal from "sweetalert";
import axios from "axios";
import Button from "@material-ui/core/Button";
import "../../modal.css";
import { api_path } from "../../shared";
function AddCancelModal(props) {
  const [REMARK, SET_REMARK] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isRejectButtonDisabled, setRejectButtonDisabled] = useState(true);
  const [getOrderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [selectOrderStatus, setSelectOrderStatus] = useState([]);
  useEffect(() => {
    let order_status = props.ORDER_STATUS;
    // if (order_status == "0" || order_status == "3" || order_status == "4" || order_status == "5" || order_status == "6"
    //     || order_status == "7" || order_status == "8" || order_status == "9"
    // ) {
    if (order_status == "0" || order_status == "3" || order_status == "9") {
      //draft ,reject,cancel
      setRejectButtonDisabled(false);
      setRejectButtonDisabled(false);
    } else {
      setRejectButtonDisabled(true);
    }
  });
  useEffect(() => {
    //fetchOrderStatus();
  }, []);
  // const fetchOrderStatus = () => {
  //   axios
  //     .get(api_path + `/MS_INQUIRY_MASTER.php?type=REJECT_CS`)
  //     .then((response) => {
  //       setOrderStatusList(response.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  const handleOrderStatusChange = (obj) => {
    setSelectOrderStatus(obj.value);
    setOrderStatus({
      value: obj.value,
      label: obj.label,
    });
  };
  const optionsCancel = [
    { value: "1", label: "Product not ready/Production issue" },
    { value: "2", label: "Consignees cancel order" },
    { value: "3", label: "Rate issue" },
    {
      value: "4",
      label: "Cannot get booking from Carrier / Get booking too late",
    },
    { value: "5", label: "Customer gets booking Direct shipping line" },
    { value: "6", label: "Vessel delay/Rollover" },
    { value: "7", label: "Container shortage" },
    { value: "9", label: "Reciprocal tariff rates" },
    { value: "8", label: "Others" },
  ];
  function updateOrderStatus(ORDER_ID, REMARK, USER_ID) {
    var data = {
      ORDER_ID: ORDER_ID,
      ORDER_STATUS: 9,
      REMARK: REMARK,
      REASON_ID: selectOrderStatus,
      REASON_NAME: getOrderStatus.label,
      USER_ID: USER_ID,
    };
    fetch(api_path + "/TS_SALES_ORDER_UPDATE_STATUS.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result["status"] == "200") {
          swal("Done.", "Save data successfully.", "success", {
            buttons: true,
            timer: 5000,
          }).then(function () {
            const url =
              api_path +
              "/SENDMAIL_SALESORDER.php?order_id=" +
              ORDER_ID +
              "&flag=cancel&order_status=9";
            axios
              .get(url)
              .then((response) => {
                // handle success
                console.log(result["message"]);
              })
              .then((data) => {
                console.log(data);
                // Handle data
              })
              .catch((error) => {
                // handle errors
              });
            window.location = "./SalesOrderDetail?order_id=" + ORDER_ID + "";
            ////////////////////////////////////////////////////
          });
        } else {
          swal("Sorry", result["message"], "error", {
            buttons: true,
            timer: 1000,
          });
        }
      });
  }
  return (
    <>
      <Button
        disabled={!isRejectButtonDisabled}
        type="button"
        fullWidth
        variant="contained"
        color="secondary"
        onClick={handleShow}
      >
        CANCEL
      </Button>

      <Modal
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Cancel Sales Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              handleClose();
              e.preventDefault();
              updateOrderStatus(props.ORDER_ID, REMARK, props.USER_ID);
            }}
            id="editmodal"
            className=""
          >
            <input type="hidden" value={props.ORDER_ID} />

            <label>
              Cancellation Reason:
              <Select
                styles={{
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
                placeholder="Select..."
                value={getOrderStatus}
                options={optionsCancel}
                onChange={handleOrderStatusChange}
                getOptionLabel={(x) => x.label}
                getOptionValue={(x) => x.value}
                required
              />
            </label>
            <label>Remark:</label>
            <textarea
              id="txtArea"
              rows="3"
              cols="50"
              value={REMARK}
              onChange={(e) => SET_REMARK(e.target.value)}
              required
              inputProps={{ maxLength: 250 }}
            ></textarea>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary" form="editmodal">
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddCancelModal;
